import { useEffect, useState } from "react";
import { getCatalog, money } from "../lib/api";

export default function Catalog() {
  const [data, setData] = useState({ service_catalog: [], product_lines: [] });

  useEffect(() => { getCatalog().then(setData); }, []);

  return (
    <div className="p-6 md:p-10">
      <h1 className="font-display text-3xl font-black text-zinc-50">Service Catalog</h1>
      <p className="mt-2 max-w-2xl text-sm text-zinc-500">
        The single pricing source of truth. Quotes may only be assembled from these items — the app never writes back into pricing tables.
      </p>

      <h2 className="mt-12 font-mono-tech text-xs text-brand-pink">Product lines</h2>
      <div className="mt-4 grid border-t border-l border-zinc-900 sm:grid-cols-2 lg:grid-cols-3">
        {data.product_lines.map((p) => (
          <div key={p.key} className="border-b border-r border-zinc-900 p-6" data-testid={`product-line-${p.key}`}>
            <p className="font-display font-bold text-zinc-50">{p.name}</p>
            <p className="mt-2 text-sm leading-relaxed text-zinc-500">{p.summary}</p>
          </div>
        ))}
      </div>

      <h2 className="mt-14 font-mono-tech text-xs text-brand-indigo">Catalog items</h2>
      <div className="mt-4 border-t border-zinc-900" data-testid="catalog-table">
        {data.service_catalog.map((s) => (
          <div key={s.sku} className="grid gap-2 border-b border-zinc-900 py-5 md:grid-cols-[100px_1.4fr_2fr_auto_120px] md:items-center" data-testid={`catalog-row-${s.sku}`}>
            <p className="font-mono-tech text-[10px] text-zinc-500">{s.sku}</p>
            <p className="font-display font-bold text-zinc-50">{s.name}</p>
            <p className="text-sm text-zinc-500">{s.description}</p>
            <p className="font-mono-tech text-[10px] text-zinc-400">{s.duration}</p>
            <p className="font-mono-tech text-[11px] text-brand-pink md:text-right">{money(s.price_low)}–{money(s.price_high)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
